import React from "react";

const ShareIcon = ({ width, height, fill, onClick }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 19"
      fill={fill}
      onClick={onClick}
    >
      <path
        d="M14.0451 18.6849C13.2666 18.6849 12.6049 18.4124 12.0599 17.8674C11.5149 17.3224 11.2424 16.6607 11.2424 15.8821C11.2424 15.7731 11.2502 15.6601 11.2658 15.543C11.2813 15.4259 11.3047 15.321 11.3358 15.2282L4.74942 11.3978C4.48472 11.6313 4.18888 11.8144 3.86189 11.9471C3.53491 12.0798 3.19235 12.1458 2.83422 12.1452C2.05569 12.1452 1.39393 11.8727 0.848957 11.3277C0.303982 10.7827 0.0314941 10.121 0.0314941 9.34243C0.0314941 8.5639 0.303982 7.90214 0.848957 7.35717C1.39393 6.81219 2.05569 6.5397 2.83422 6.5397C3.19235 6.5397 3.53491 6.60603 3.86189 6.7387C4.18888 6.87136 4.48472 7.05416 4.74942 7.2871L11.3358 3.4567C11.3047 3.36328 11.2813 3.25833 11.2658 3.14186C11.2502 3.02539 11.2424 2.91235 11.2424 2.80273C11.2424 2.02419 11.5149 1.36244 12.0599 0.817463C12.6049 0.272488 13.2666 0 14.0451 0C14.8237 0 15.4854 0.272488 16.0304 0.817463C16.5754 1.36244 16.8479 2.02419 16.8479 2.80273C16.8479 3.58127 16.5754 4.24302 16.0304 4.788C15.4854 5.33297 14.8237 5.60546 14.0451 5.60546C13.687 5.60546 13.3445 5.53944 13.0175 5.4074C12.6905 5.27536 12.3946 5.09225 12.1299 4.85807L5.54353 8.68846C5.57467 8.78189 5.59803 8.88715 5.6136 9.00424C5.62917 9.12133 5.63695 9.23406 5.63695 9.34243C5.63695 9.45143 5.62917 9.56447 5.6136 9.68156C5.59803 9.79866 5.57467 9.9036 5.54353 9.9964L12.1299 13.8268C12.3946 13.5932 12.6905 13.4104 13.0175 13.2784C13.3445 13.1464 13.687 13.08 14.0451 13.0794C14.8237 13.0794 15.4854 13.3519 16.0304 13.8969C16.5754 14.4418 16.8479 15.1036 16.8479 15.8821C16.8479 16.6607 16.5754 17.3224 16.0304 17.8674C15.4854 18.4124 14.8237 18.6849 14.0451 18.6849Z"
        fill={fill}
      />
    </svg>
  );
};

ShareIcon.defaultProps = {
  width: 17,
  height: 19,
  fill: "black",
};

export default ShareIcon;
